import { FilterCheckbox, translateLanguage, useSettings } from "@repo/ui";
import { isChecked } from "@repo/utils";
import isEmpty from "lodash/isEmpty";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const PreferredLanguageFilter = ({
  filters,
  actions,
}: FilterItemsProps) => {
  const { general } = useSettings();

  if (isEmpty(general?.supported_languages)) {
    return null;
  }
  return (
    <FilterListContainer id="preferred-language-filter">
      {general?.supported_languages.map((language) => (
        <FilterCheckbox
          key={language}
          id={language}
          label={translateLanguage(language)}
          checked={isChecked(filters.customerLocales, language)}
          onCheckFilter={actions.setCustomerLocales}
          value={language}
        />
      ))}
    </FilterListContainer>
  );
};
